export const version = 'kunde-v1.20.0-SNAPSHOT-90d656ac56d34d201865b5fbb03ac75a3fbed8e5';